import React from 'react';
import { ContactUsComponent } from './contact-us-component';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { useGlobalState } from '../global/context/global-context';
import PortalAppService from '../../application/platform/portal-app-service';
import { IContactUsRequest } from '../../model/base/request/contact-us-request';

export const ContactUsFactory: React.FC = () => {
  const { applicationData } = useGlobalState();

  const handleSubmit = async (data: IContactUsRequest) => {
    await PortalAppService.sendContactMessage(data);
  };

  // Format address from entity data
  const formatAddress = () => {
    const address = applicationData?.entity?.address;
    if (!address) return undefined;

    const parts = [
      address.street,
      address.number,
      address.neighborhood,
      address.city,
      address.state,
      address.formattedZipCode,
    ].filter(Boolean);

    return parts.length > 0 ? parts.join(', ') : undefined;
  };

  // Get phone from contact data
  const getPhone = () => {
    const contact = applicationData?.entity?.contact;
    return contact?.formattedBusinessPhone ||
           contact?.formattedHousePhone ||
           contact?.formattedMobilePhone ||
           undefined;
  };

  // Get email from contact data
  const getEmail = () => {
    return applicationData?.entity?.contact?.email;
  };

  return (
    <BaseLayoutFactory>
      <ContactUsComponent
        onSubmit={handleSubmit}
        entityName={applicationData?.entity?.nickName}
        entityAddress={formatAddress()}
        entityPhone={getPhone()}
        entityEmail={getEmail()}
        entityWorkingHours={applicationData?.entity?.operatingHours}
      />
    </BaseLayoutFactory>
  );
};
